module.exports = __webpack_public_path__ + "img/tips6_1.8a7caa4e.png";